module.exports = __webpack_public_path__ + "img/xiazai02@3x.92ba101e.png";